import { Action, Enum, PlainObject, State } from "@zyzgroup/core-common";

// 车牌颜色
export const XgPlateColorEnum = new Enum({
  BLUE: { serverValue: "b", serverDescription: "蓝牌" },
  GREEN: { serverValue: "g", serverDescription: "绿牌" },
  YELLOW: { serverValue: "y", serverDescription: "黄牌" },
  YELLOW_GREEM: { serverValue: "q", serverDescription: "黄绿" },
  BLACK: { serverValue: "d", serverDescription: "黑牌" },
  WHITE: { serverValue: "w", serverDescription: "白牌" },
  UNKNOWN: { serverValue: "", serverDescription: "未知" }
});

// 车牌认证类型
export const XgPlateCertifyTypeEnum = new Enum({
  NORMAL: { serverValue: "c", serverDescription: "普通车" },
  DISABLED: { serverValue: "d", serverDescription: "残疾人车" }
});

// 车牌认证状态
export const XgPlateCertifyStatusEnum = new Enum({
  // 已绑定
  REVIEW: { serverValue: "waitting", serverDescription: "审核中" },
  ACCEPT: { serverValue: "passed", serverDescription: "已认证" },
  REJECT: { serverValue: "unpassed", serverDescription: "认证失败" }
});

function reduce(state: State, payload: PlainObject): State {
  // 车牌颜色
  state.color = payload.color || "";
  // 车牌号
  state.plate = payload.plate || "";
  state.colorFormatted = XgPlateColorEnum.getName(state.color);
  return state;
}

export default (immutable = true) =>
  (state: State, action: Action) => {
    const nextState: State = immutable ? { ...state } : state;
    const payload = action.payload || {};
    switch (action.type) {
      case "SET_PLATE":
      case "INIT":
        // 初始化
        reduce(nextState, payload);
        break;
    }
    return nextState;
  };
